<div class="container">
  <div></div>
  <div>

    <div class="rte">
      <h1>Terms &amp; Conditions</h1>
      <h2>Terms of website use</h2>
      Please read these terms of use carefully before you start to use the site. By using our site, you indicate that you accept
      these terms of use and that you agree to abide by them. If you do not agree to these terms of use, please refrain from
      using our site.
      <br>
      <br>
      <h2>Reliance On Information Posted &amp; Disclaimer</h2>
      The materials contained on our site are provided for general information purposes only and do not claim to be or constitute
      legal or other professional advice and shall not be relied upon as such.
      <br>
      <br>We do not accept any responsibility for any loss which may arise from accessing or reliance on the information on this
      site and to the fullest extent permitted by English law, we exclude all liability for loss or damages direct or indirect
      arising from use of this site.
      <br>
      <br>
      <h2>Information about us</h2>
      www.4DML.com is a site operated by 4D Monitoring Ltd (“We”); we are a Company registered in England and Wales under registration
      number 09839120. Our registered office is LDH House, Parsons Green, St. Ives, England, PE27 4AA. Our VAT number is ????????.
      <br>
      <br>
      <h2>Accessing our site</h2>
      Access to our site is permitted on a temporary basis, and we reserve the right to withdraw or amend the service we provide
      on our site without notice (see below). We will not be liable if for any reason our site is unavailable at any time
      or for any period.
      <br>
      <br>
      <h2>Intellectual property rights</h2>
      We are the owner or the licensee of all intellectual property rights in our site, and in the material published on it. Those
      works are protected by copyright laws and treaties around the world. All such rights are reserved.
      <br>
      <br>You may print off one copy, and may download extracts, of any page(s) from our site for your personal reference and
      you may draw the attention of others within your organisation to material posted on our site.
      <br>
      <br>You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way, and
      you must not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying
      text.
      <br>
      <br>Our status (and that of any identified contributors) as the authors of material on our site must always be acknowledged.
      <br>
      <br>You must not use any part of the materials on our site for commercial purposes without obtaining a licence to do so
      from us or our licensors.
      <br>
      <br>If you print off, copy or download any part of our site in breach of these terms of use, your right to use our site
      will cease immediately and you must, at our option, return or destroy any copies of the materials you have made.
      <br>
      <br>
      <h2>Our site changes regularly</h2>
      We aim to update our site regularly, and may change the content at any time. If the need arises, we may suspend access to
      our site, or close it indefinitely. Any of the material on our site may be out of date at any given time, and we are
      under no obligation to update such material.
      <br>
      <br>
      <h2>Our liability</h2>
      The material displayed on our site is provided without any guarantees, conditions or warranties as to its accuracy. To the
      extent permitted by law, we, and third parties connected to us hereby expressly exclude:
      <br>
      <br>All conditions, warranties and other terms which might otherwise be implied by statute, common law or the law of equity.
      <br>Any liability for any direct, indirect or consequential loss or damage incurred by any user in connection with our
      site or in connection with the use, inability to use, or results of the use of our site, any websites linked to it
      and any materials posted on it, including, without limitation any liability for:
      <br>loss of income or revenue;
      <br>loss of business;
      <br>loss of profits or contracts;
      <br>loss of anticipated savings;
      <br>loss of data;
      <br>loss of goodwill;
      <br>wasted management or office time; and
      <br>for any other loss or damage of any kind, however arising and whether caused by tort (including negligence), breach
      of contract or otherwise, even if foreseeable, provided that this condition shall not prevent claims for loss of or
      damage to your tangible property or any other claims for direct financial loss that are not excluded by any of the
      categories set out above.
      <br>
      <br>This does not affect our liability for death or personal injury arising from our negligence, nor our liability for
      fraudulent misrepresentation or misrepresentation as to a fundamental matter, nor any other liability which cannot
      be excluded or limited under applicable law.
      <br>
      <br>
      <h2>Information about you and your visits to our site</h2>
      We process information about you in accordance with our privacy policy. By using our site, you consent to such processing
      and you warrant that all data provided by you is accurate.
      <br>
      <br>
      <h2>Viruses, hacking and other offences</h2>
      You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious
      or technologically harmful. You must not attempt to gain unauthorised access to our site, the server on which our site
      is stored or any server, computer or database connected to our site. You must not attack our site via a denial-of-service
      attack or a distributed denial-of service attack.
      <br>
      <br>By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will report
      any such breach to the relevant law enforcement authorities and we will co-operate with those authorities by disclosing
      your identity to them. In the event of such a breach, your right to use our site will cease immediately.
      <br>
      <br>We will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses or other technologically
      harmful material that may infect your computer equipment, computer programs, data or other proprietary material due
      to your use of our site or to your downloading of any material posted on it, or on any website linked to it.
      <br>
      <br>
      <h2>Links from our site</h2>
      Where our site contains links to other sites and resources provided by third parties, these links are provided for your information
      only. We have no control over the contents of those sites or resources, and accept no responsibility for them or for
      any loss or damage that may arise from your use of them. When accessing a site via our website we advise you check
      their terms of use and privacy policies to ensure compliance and determine how they may use your information.
      <br>
      <br>
      <h2>Jurisdiction and applicable law</h2>
      The English courts will have non-exclusive jurisdiction over any claim arising from, or related to, a visit to our site.
      <br>
      <br>These terms of use and any dispute or claim arising out of or in connection with them or their subject matter or formation
      (including non-contractual disputes or claims) shall be governed by and construed in accordance with the law of England
      and Wales.
      <br>
      <br>
      <h2>Trade marks</h2>
      4DML is a UK registered trade mark of 4D Monitoring Ltd.
      <br>
      <br>
      <h2>Variations</h2>
      We may revise these terms of use at any time by amending this page. You are expected to check this page from time to time
      to take notice of any changes we made, as they are binding on you. Some of the provisions contained in these terms
      of use may also be superseded by provisions or notices published elsewhere on our site.
      <h2></h2>
      <h2>Your concerns</h2>
      If you have any concerns about material which appears on our site, please contact askus&#64;4dml.com.
      <br>Thank you for visiting our site.
      <br>
      <br>
      <p><button class="btn btn-primary btn-block" (click)="acceptedTerms()">Accept Terms &amp; Conditions</button></p>
      <br>
    </div>
  </div>
  <div></div>
</div>
